const [ _, root, role, slug ] = window.location.pathname.split(/\//)

export const API_ROOT = `/${root}/${role}/${slug}`

export const ROLE = role

let meta = document.querySelector('meta[name="csrf-token"]')

export const HEADERS = {
  // Used by API and Web Socket calls to ensure network communication
  // is only coming from us.
  'X-CSRF-Token': meta ? meta.getAttribute('content') : null,
  'Accept': 'application/json',
  'Content-Type': 'application/json'
}

export const HTML_HEADERS = {
  'X-CSRF-Token': meta ? meta.getAttribute('content') : null,
  'Content-Type': 'application/x-www-form-urlencoded'  
}
